import {Component, Output, EventEmitter, OnInit } from '@angular/core';
import { InjiService } from '../../shared/service/inji.service';
import firebase from "firebase/app";
import "firebase/database";
import { SimpleModalService } from 'ngx-simple-modal';
import { ConfirmComponent } from '../../shared/components/alert/confirm/confirm.component';

@Component({
    selector: 'reject-component',
    template: `
	    <div class="d-flex flex-nowrap text-white">
	      <button type="button" class="btn btn-info" (click)="resend()">
	        <i class="fa fa-arrow-right"></i>
	      </button>
	    </div>
    `,
    styles: [`.d-flex{justify-content:center;}`]
})
export class ResendComponent implements OnInit  {

    rowData: any;


    @Output() save: EventEmitter<any> = new EventEmitter();

    constructor(
    	private InjiService: InjiService,
	    private SimpleModalService: SimpleModalService
    	){
    }
    ngOnInit(){
    }
    resend() {
        this.SimpleModalService.addModal(ConfirmComponent, {
          title: 'Tasdiqlash',
          message: 'Ma\'lumotlar to\'g\'rimi?'})
          .subscribe((isConfirmed) => {
            if (isConfirmed) {
            	this.InjiService.updateRowSubjects.next({action:'resend', data:this.rowData})
            }
        });
    }
}
